<script>
    import Library, {getFields, getItem} from '../Models/LibraryORM';
    import {notifier} from '@beyonk/svelte-notifications';
    import {addFormModal} from '../Forms/ModalFormManager.svelte';
    import {uniqBy} from "lodash-es";
    import parseFields from '../Utilities/parseFields';

    export let section_id;
    export let mapped_items;

    export let control;

    export let assessment;
    let sortFields = [];
    let formFields = [];

    let added_items = new Set();

    async function getLibraryFields(s) {
        if (s.section_type == "library") {
            let formData = await Library.getFieldData(s.library_type);

            sortFields = formData.sortFields;
            formFields = formData.formFields;

            if (s.extra_fields) {
                let extraFieldData = parseFields(s.extra_fields, false);
                formFields.push(...extraFieldData.formFields);
            }

            let tags = [];
            let library_tags = assessment.library_tags[s.section_name];

            if (s.tags) {
                tags = [...section.tags];
            }


            if (library_tags && library_tags.tags) {
                tags = [...tags, ...library_tags.tags];
            }

            // handle tag field
            if (tags.length) {
                formFields.push({name: "tags_", label: "Tags", type:"customTags", options: tags})
            }
        }
    }

    function getAddedItems(section) {
        let library_items = assessment.report_data[section.section_name];

        if (library_items) {
            added_items = new Set(library_items.map(item => item.template_id));
        }
    }

    function addTemplatedItem(item) {
        // create a copy of item;
        let cloned = JSON.parse(JSON.stringify(item));
        cloned.template_id = cloned._id;
        cloned._id = undefined;
        cloned._rev = undefined
        cloned.type = undefined;

        cloned.control_id = control.id;

        addFormModal({
            fields: formFields,
            data: cloned
        }).then((data) => {
            assessment.model.saveLibraryItem(section, data).then(() => {
                notifier.success("Item Added");
            });
        })

    }


    let item_cache = {};
    async function getItemMemoized(item_id) {
        if (!item_cache[item_id]) {
            item_cache[item_id] = await getItem(item_id);
        }

        return item_cache[item_id]
    }

    $: section = assessment.assessment_type_data.report_sections.filter((s) => s.section_id == section_id)[0];
    $: {
        if (section) {
            getLibraryFields(section)
            getAddedItems(section);
        }
    }
</script>

{#if section}
    <h3 class="title is-5">
        {section.section_name}
    </h3>

    <table class="table is-fullwidth">
        <tr>
            {#each sortFields as field}
                {#if !field.default_hidden}
                    <th>{field.label}</th>
                {/if}
            {/each}
        </tr>
        {#each uniqBy(mapped_items, (el) => el.id) as item (item.id)}
        <tr class:added={added_items.has(item.id)}>
            {#await getItemMemoized(item.id)}
                <td colspan={sortFields.length}>Loading...</td>
            {:then library_item}
                {#each sortFields as field}
                    {#if !field.default_hidden}
                        <td class="is-v-centered">
                            {#if field.component}
                                <svelte:component this={field.component} value={library_item[field.field]} {...field.componentProps}></svelte:component>
                            {:else}
                                {library_item[field.field]}
                            {/if}
                        </td>
                    {/if}
                {/each}
                <td class="is-h-centerd is-v-centered">
                    <div class="button has-text-weight-bold" on:click={addTemplatedItem(library_item)}>Add Item</div>
                </td>
            {/await}
        </tr>
        {/each}
    </table>
{/if}
<style>
    .added {
        background-color: lightgray;
    }
</style>